<template>
  <v-container grid-list-md fluid>
    <v-layout row wrap>
      <!-- Timeline Slide-Out Navigation Drawer -->
      <v-navigation-drawer v-model="drawer" temporary fixed right dark>
        <v-card class="mx-auto" max-width="550" dark flat>
          <v-card-title class="pa-2 red lighten-1">
            <v-btn icon>
              <v-icon>mdi-menu</v-icon>
            </v-btn>
            <h3 class="title font-weight-light text-xs-center grow">
              {{ timelineItem.worknum }} Timeline
            </h3>
          </v-card-title>

          <v-card-text class="py-0">
            <h3 class="title text-xs-center grow">
              Status : {{ timelineItem.status }}
            </h3>
            <h4
              class="title text-xs-center grow"
              v-if="timelineItem.status === 'In Factory'"
            >
              Due Week: {{ timelineItem.deliverydate | moment("w") }}
            </h4>
            <h3 class="pt-3">Rod Book : {{ timelineItem.jobNotes }}</h3>
            <h3 class="pt-3">{{ timelineItem.extra }}</h3>
            <h3 class="pt-3">
              Del List : {{ timelineItem.notes }} , {{ timelineItem.notes2 }}
            </h3>
            <!-- Timeline -->
            <v-timeline align-top dense>
              <v-timeline-item color="teal" small>
                <v-layout pt-3>
                  <v-flex xs4>
                    <strong>Created</strong>
                  </v-flex>
                  <v-flex>
                    <div class="caption">{{ timelineItem.createdBy }}</div>
                    <div class="caption">{{ timelineItem.date }}</div>
                  </v-flex>
                </v-layout>
              </v-timeline-item>

              <v-timeline-item
                color="teal"
                small
                v-if="timelineItem.toFactory === true"
              >
                <v-layout pt-3>
                  <v-flex xs4>
                    <strong>To Factory</strong>
                  </v-flex>
                  <v-flex>
                    <div class="caption">{{ timelineItem.toFactoryby }}</div>
                    <div class="caption">{{ timelineItem.toFactoryat }}</div>
                  </v-flex>
                </v-layout>
              </v-timeline-item>

              <v-timeline-item
                color="teal"
                small
                v-for="(keys, values) in timelineItem.objects"
                v-bind:key="values"
              >
                <v-layout pt-3>
                  <v-flex xs4>
                    <strong>{{ values }}</strong>
                  </v-flex>
                  <v-flex>
                    <strong></strong>
                    <div class="caption">{{ Object.values(keys)[2] }}</div>
                    <div class="caption">{{ Object.values(keys)[1] }}</div>
                  </v-flex>
                </v-layout>
              </v-timeline-item>

              <v-timeline-item
                color="teal"
                small
                v-if="timelineItem.status === 'ON HOLD'"
              >
                <v-layout pt-3>
                  <v-flex xs4>
                    <strong>{{ timelineItem.status }}</strong>
                  </v-flex>
                  <v-flex>
                    <div class="caption">{{ timelineItem.heldby }}</div>
                    <div class="caption">{{ timelineItem.heldat }}</div>
                  </v-flex>
                </v-layout>
              </v-timeline-item>

              <v-timeline-item
                color="teal"
                small
                v-if="timelineItem.status === 'Delivered'"
              >
                <v-layout pt-3>
                  <v-flex xs4>
                    <strong>{{ timelineItem.status }}</strong>
                  </v-flex>
                  <v-flex>
                    <div class="caption">{{ timelineItem.deliveredBy }}</div>
                    <div class="caption">{{ timelineItem.deliveredAt }}</div>
                  </v-flex>
                </v-layout>
              </v-timeline-item>

              <v-timeline-item
                color="teal"
                small
                v-if="timelineItem.invoiceNum != ' '"
              >
                <v-layout pt-3>
                  <v-flex xs4>
                    <strong>{{ timelineItem.invoiceNum }}</strong>
                  </v-flex>
                  <v-flex>
                    <div class="caption">
                      <strong>{{ timelineItem.invoicedTime }}</strong>
                    </div>
                    <div class="caption">
                      <strong>By: {{ timelineItem.invoicedBy }}</strong>
                    </div>
                  </v-flex>
                </v-layout>
              </v-timeline-item>

              <v-timeline-item
                color="teal"
                small
                v-if="timelineItem.deliveryNum != ' '"
              >
                <v-layout pt-3>
                  <v-flex xs4>
                    <strong>{{ timelineItem.deliveryNum }}</strong>
                  </v-flex>
                  <v-flex>
                    <div class="caption">
                      <strong>{{ timelineItem.deliveryNumTime }}</strong>
                    </div>
                    <div class="caption">
                      <strong>By: {{ timelineItem.deliveryNumName }}</strong>
                    </div>
                  </v-flex>
                </v-layout>
              </v-timeline-item>

              <v-timeline-item
                color="teal"
                small
                v-if="timelineItem.sRef != ' '"
              >
                <v-layout pt-3>
                  <v-flex xs4>
                    <strong>{{ timelineItem.sRef }}</strong>
                  </v-flex>
                  <v-flex>
                    <div class="caption">
                      <strong>{{ timelineItem.sReftime }}</strong>
                    </div>
                    <div class="caption">
                      <strong>By: {{ timelineItem.sRefname }}</strong>
                    </div>
                  </v-flex>
                </v-layout>
              </v-timeline-item>
            </v-timeline>

            <div>
              <v-layout pt-3>
                <v-flex xs4>
                  <strong>Purchase orders</strong>
                </v-flex>
                <v-flex>
                  <div
                    class="caption"
                    v-for="i in timelineItem.costs"
                    v-bind:key="i.id"
                  >
                    <strong>{{ i.ordernum }} - {{ i.supplier }}</strong>
                  </div>
                </v-flex>
              </v-layout>
            </div>
          </v-card-text>
        </v-card>
        <!-- End of Timeline Slide-Out Navigation Drawer -->
      </v-navigation-drawer>

      <!-- Main Page Content -->

      <!-- Main Data Table -->
      <v-flex xs12>
        <!-- CRUD table -->
        <v-card>
          <v-card-title class="primary white--text">
            <!-- Add Sales Order Button and Popup Dialog -->
            <v-dialog v-model="add" max-width="500px">
              <template v-slot:activator="{ on }">
                <v-btn class="success mx-1 mb-2" v-on="on"
                  >Add Sales Order</v-btn
                >
              </template>
              <v-form class="px-3 white" ref="form">
                <h1 class="headline pt-4">New Sales Order</h1>
                <v-container grid-list-md>
                  <v-layout wrap>
                    <v-select
                      v-model="product"
                      :items="items"
                      :rules="[(v) => !!v || 'Product type is required']"
                      prepend-icon="whatshot"
                      label="Select products"
                      required
                      multiple
                      chips
                    ></v-select>
                    <v-flex>
                      <v-text-field
                        v-for="i in this.product.length"
                        :key="`product${i}`"
                        :label="'Quantity: ' + product[i - 1]"
                        v-model.number="qty[i]"
                        prepend-icon="spa"
                      ></v-text-field>
                    </v-flex>
                    <v-flex>
                      <v-text-field
                        label="Customer"
                        v-model="customer"
                        prepend-icon="beach_access"
                        :rules="inputRules"
                      ></v-text-field>
                    </v-flex>
                    <v-flex>
                      <v-text-field
                        label="Contract"
                        v-model="contract"
                        prepend-icon="cake"
                        :rules="inputRules"
                      ></v-text-field>
                    </v-flex>
                    <v-flex>
                      <v-text-field
                        label="customer order#"
                        v-model="ordernum"
                        prepend-icon="spa"
                      ></v-text-field>
                    </v-flex>
                    <v-flex>
                      <v-text-field
                        label="Location"
                        v-model="location"
                        prepend-icon="spa"
                      ></v-text-field>
                    </v-flex>
                    <v-spacer></v-spacer>
                    <v-flex>
                      <v-checkbox
                        v-model="fsc_checkbox"
                        :label="`FSC: ${fsc_checkbox.toString()}`"
                      ></v-checkbox>
                    </v-flex>
                    <v-spacer></v-spacer>
                    <v-flex
                      ><!--submit-->
                      <v-btn class="success" @click="submit"
                        >Create Sales Order</v-btn
                      >
                    </v-flex>
                    <v-spacer></v-spacer>
                    <v-flex>
                      <v-btn class="error" @click="cancel">Cancel</v-btn>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-form>
              <!-- End of New Sales Order Popup Dialog -->
            </v-dialog>
            <!-- Download Data Button -->
            <v-btn class="success mb-2 mx-1">
              <download-excel :data="orders">Download Data</download-excel>
            </v-btn>
            <!-- TEST Database Button 
            <v-btn class="error mb-2 mx-1" @click="getDocdata()">Test Database</v-btn>-->
            <!-- Spacer -->
            <v-spacer></v-spacer>
            <!-- Search Field -->
            <v-text-field
              class="mb-2 mx-1"
              dark
              v-model="search"
              append-icon="search"
              label="Search"
              single-line
              hide-details
            ></v-text-field>
          </v-card-title>
          <!-- Main data table -->
          <v-data-table
            dense
            :headers="headers"
            :items="orders"
            sort-by="name"
            :search="search"
          >
            <template v-slot:item.action="{ item }">
              <div class="text-center">
                <!-- Edit Button and Tooltip -->
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-btn color="black" tile icon x-small v-on="on">
                      <v-icon small @click="editItem(item)">edit</v-icon>
                    </v-btn>
                  </template>
                  <span>Edit</span>
                </v-tooltip>

                <!-- Delete Button and Tooltip -->
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-btn color="black" tile icon x-small v-on="on">
                      <v-icon small @click="deleteItem(item)">delete</v-icon>
                    </v-btn>
                  </template>
                  <span>Delete</span>
                </v-tooltip>

                <!-- Timeline Button and Tooltip -->
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-btn color="black" tile icon x-small v-on="on">
                      <v-icon small @click="getInfo(props.item)" outline
                        >info</v-icon
                      >
                    </v-btn>
                  </template>
                  <span>Timeline</span>
                </v-tooltip>

                <!-- Complete Item Button and Tooltip -->
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-btn color="black" tile icon x-small v-on="on">
                      <v-icon small @click="completeItem(item)"
                        >done_outline</v-icon
                      >
                    </v-btn>
                  </template>
                  <span>Complete Item</span>
                </v-tooltip>
              </div>
            </template>
            <template v-slot:no-data>
              <v-btn color="primary" @click="initialize">Reset</v-btn>
            </template>
          </v-data-table>
          <!-- End of CRUD table -->
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import db from "@/fb";
import moment from "moment";
import firebase from "firebase";
import { setInterval } from "timers";
export default {
  data: () => ({
    fsc_checkbox: false,
    rowsPerPageItems: [10, 20, 40, 80, 120, 160, 200],
    pagination: {
      rowsPerPage: 80,
    },
    isMobile: false,
    dialog: false,
    timeline: false,
    inputRules: [(v) => v.length >= 3 || "Min Length 3 Chars"],
    inputRules2: [(v) => v.length >= 1 || "Min Length 1 Chars"],
    items: [
      "Frame",
      "Doors",
      "Timber Section",
      "Screens",
      "Glass",
      "Ironmongory",
    ],
    docdata: [],
    search: "",
    worknum: " ",
    timer: "",
    ordernum: " ",
    customer: " ",
    contract: " ",
    location: " ",
    allowSpaces: "_",
    loading: false,
    product: "",
    bcode: " ",
    select: " ",
    code: " ",
    qty: [],
    add: false,
    factory: "false",
    fsc: "",
    date: "",
    steps: {},
    headers: [
      {
        text: "Work #",
        align: "left",
        value: "worknum",
      },
      {
        text: "Customer",
        align: "left",
        value: "customer",
      },
      {
        text: "Contract",
        align: "left",
        value: "contract",
        sortable: false,
      },
      {
        text: "Order #",
        align: "left",
        value: "ordernum",
        sortable: false,
      },
      {
        text: "Product",
        align: "left",
        value: "product",
      },
      {
        text: "Status",
        align: "left",
        value: "status",
      },
      {
        text: "Progress",
        align: "left",
        value: "progress",
      },
      {
        text: "FSC",
        align: "left",
        value: "fsc",
      },
      {
        text: "Date",
        align: "left",
        value: "date",
        sortable: false,
      },
      {
        text: "Invoice #",
        align: "left",
        value: "invoiceNum",
        sortable: false,
      },
      {
        text: "Delivery Note #",
        align: "left",
        value: "deliveryNum",
        sortable: false,
      },
      {
        text: "Sch Ref",
        align: "left",
        value: "sRef",
        sortable: false,
      },
      {
        text: "Job Notes",
        align: "left",
        value: "jobNotes",
        sortable: false,
      },
      {
        text: "Actions",
        align: "left",
        value: "action",
        sortable: false,
      },
    ],
    orders: [],
    costs: [],
    testOrders: [],
    drawer: false,
    status: null,
    editedIndex: -1,
    timelineItem: {
      worknum: "",
      customer: "",
      contract: "",
      ordernum: "",
      product: "",
      location: "",
      progress: 0,
      fsc: "",
      qty: 0,
      date: "",
      steps: null,
      timeline: null,
      createdBy: "",
    },
    editedItem: {
      worknum: " ",
      customer: " ",
      contract: " ",
      ordernum: " ",
      qty: 0,
      product: " ",
      fsc: " ",
      date: " ",
      invoiceNum: " ",
      deliveryNum: " ",
      jobNotes: " ",
    },
    defaultItem: {
      worknum: " ",
      customer: " ",
      contract: " ",
      ordernum: " ",
      product: " ",
      fsc: " ",
      qty: 0,
      date: " ",
      invoiceNum: " ",
      deliveryNum: " ",
      jobNotes: " ",
    },
  }),
  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "New Item" : "Edit Item";
    },
    authenticated() {
      return JSON.parse(localStorage.getItem("authenticated"));
    },

    /*  rod(){
        this.orders = this.$store.getters.rod
        return this.orders
      }*/
  },
  mounted() {
    //console.log('App mounted!');
    //this.$store.dispatch('fetchRod')
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
  },
  created() {
    /*
    the only way to update an existing property or index of an array and have it be reactive is to use:
     vm/this.$set(object/array, property/index, update)
    Or you can use the native array splice method
    and object.assign for objects
    */
    /* GETS DATA FROM FIREBASE ALSO LOOKS FOR AND HANDLES ANY REAL TIME ADDINGS*/
    db.collection("orders").onSnapshot((res) => {
      const changes = res.docChanges();
      changes.forEach((change) => {
        if (change.type === "added") {
          this.orders.push({
            ...change.doc.data(),
            id: change.doc.id,
          });
        }
        /* if(change.type === 'modified'){
             var obj = change.doc.data()
             for(var x=0;x<this.orders.length; x++){
                 if(this.orders[x].worknum == obj.worknum){
                   this.orders[x] = obj
                 }
             }
           }*/
      });
    }),
      db.collection("costs").onSnapshot((res) => {
        const changes = res.docChanges();
        changes.forEach((change) => {
          if (change.type === "added") {
            this.costs.push({
              ...change.doc.data(),
              id: change.doc.id,
            });
          }
        });
      });
  },
  methods: {
    cancel() {
      this.add = false;
      this.fsc_checkbox = false;
    },

    async getLatestOrder() {
      //Get latest order by work order number
      return db
        .collection("orders")
        .orderBy("date", "desc")
        .limit(1)
        .get()
        .then((querySnapshot) => {
          const cache = [];
          querySnapshot.forEach((doc) => {
            // doc.data() is never undefined for query doc snapshots
            cache[doc.id] = doc.data().worknum;

            //cache[doc.id] = doc.data().worknum;
            console.log("THIS IS THE CACHE => ", cache);
            console.log(doc.id, " => ", doc.data().worknum);
            this.docdata = cache[doc.id];
            console.log("THIS IS DOCDATA =>", this.docdata);
          });
        })
        .catch(function(error) {
          console.log("Error getting documents: ", error);
        });
    },
    async getDocdata() {
      await this.getLatestOrder();
      var latestWorknum = this.docdata;
      console.log(latestWorknum);
      var prefix = latestWorknum[0];
      var suffix = Number(latestWorknum.slice(1));
      console.log("prefix ", prefix);
      console.log("suffix ", suffix);
      var prefix_charcode = prefix.charCodeAt(0); //LETTER
      var worknums = [];

      if (prefix_charcode >= 90) {
        //IF Z THEN A
        prefix_charcode = 65;
      }
      suffix = suffix + 1;
      if (suffix >= 100) {
        // example IF A99 then B01
        prefix_charcode++;
        console.log(String.fromCharCode(prefix_charcode), "<-- new char");
        suffix = 1;
      }
      console.log(suffix, "<-- Suffix");
      var res = String.fromCharCode(prefix_charcode).concat(
        suffix.toLocaleString("en-US", {
          minimumIntegerDigits: 2,
          useGrouping: false,
        })
      );
      console.log(res, "<-- result");
      worknums[i] = res;
      console.log(worknums, "<-- worknums");
      //continue the object creation here
    },

    getInfo(item) {
      var temparr = [];
      this.timelineIndex = this.orders.indexOf(item);
      this.timelineItem = Object.assign({}, item);
      for (var x = 0; x < this.costs.length; x++) {
        if (this.timelineItem.worknum === this.costs[x].worknum) {
          temparr.push(this.costs[x]);
        }
      }
      this.timelineItem.costs = temparr;
      this.drawer = true;
    },
    editItem(item) {
      this.editedIndex = this.orders.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },
    completeItem(item) {
      const index = this.orders.indexOf(item);
      const countTruthy = (a, b) => {
        return b ? a + 1 : a;
      };
      //UPDATE USERS WITH COMPLETION Check if all boxes are ticked firstly
      // console.log(item.steps)
      var count = Object.values(item.steps).reduce(countTruthy, 0);
      // console.log(count +"True Values")
      var uname = firebase.auth().currentUser.email.split("@")[0];
      if (count == Object.values(item.steps).length) {
        //ALL TRUE VALUES SO CONFIRM AND COMPLETE
        confirm("Are you sure you want to complete this item?") &&
          this.orders.splice(index, 1);
        item.status = "Delivered";
        db.collection("history")
          .add(item)
          .then(() => {
            console.log("ADDED to db");
            this.$emit("orderCreated");
          });
        db.collection("history")
          .doc(item.id)
          .update({
            status: "Delivered",
            statusUname: uname,
            statusTime: moment(new Date()).format("YYYY-MM-DD HH:mm"),
          })
          .then(() => {
            console.log("ADDED to db");
            this.$emit("Delivered");
          });
        db.collection("orders")
          .doc(item.id)
          .delete()
          .then(() => {
            console.log("ADDED to db");
            this.$emit("orderCreated");
          });
        //
      } else {
        console.log("not all true");
        alert("Order not complete");
      }
    },
    deleteItem(item) {
      //DELETES ITEM
      const index = this.orders.indexOf(item);
      confirm("Are you sure you want to cancel this item?") &&
        this.orders.splice(index, 1);
      db.collection("orders")
        .doc(item.id)
        .delete();
      db.collection("history")
        .add(item)
        .then(() => {
          console.log("ADDED to db");
          this.$emit("orderCreated");
        });
    },
    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },
    save() {
      //SAVES ANY OBJECT CHANGES TO FIREBASE
      if (this.editedIndex > -1) {
        Object.assign(this.orders[this.editedIndex], this.editedItem);
      } else {
        this.orders.push(this.editedItem);
      }
      var uname = firebase.auth().currentUser.email.split("@")[0];
      db.collection("orders")
        .doc(this.orders[this.editedIndex].id)
        .update({
          deliveryNumName: uname,
          deliveryNumTime: moment(new Date()).format("YYYY-MM-DD HH:mm"),
          invoicedBy: uname,
          invoicedTime: moment(new Date()).format("YYYY-MM-DD HH:mm"),
          worknum: this.editedItem.worknum,
          customer: this.editedItem.customer,
          contract: this.editedItem.contract,
          ordernum: this.editedItem.ordernum,
          product: this.editedItem.product,
          fsc: this.editedItem.fsc,
          date: this.editedItem.date,
          invoiceNum: this.editedItem.invoiceNum,
          deliveryNum: this.editedItem.deliveryNum,
          qty: this.editedItem.qty,
          jobNotes: this.editedItem.jobNotes,
        })
        .then(() => {
          this.$emit("Delivered");
        });
      this.close();
    },
    async createOrder() {
      await this.getLatestOrder();
      var latestWorknum = this.docdata;
      console.log(latestWorknum);
      var prefix = latestWorknum[0];
      var suffix = Number(latestWorknum.slice(1));
      console.log("prefix ", prefix);
      console.log("suffix ", suffix);
      var prefix_charcode = prefix.charCodeAt(0); //LETTER
      var worknums = [];
      for (var i = 0; i < this.product.length; i++) {
        console.log("PREFEC CHARCODE ", prefix_charcode);
        if (prefix_charcode >= 90 && suffix == 99) {
          console.log("PREFEC CHARCODE ", prefix_charcode);
          //IF Z THEN A
          prefix_charcode = 64;
        }
        suffix = suffix + 1;
        if (suffix >= 100) {
          // example IF A99 then B01
          prefix_charcode++;
          console.log(String.fromCharCode(prefix_charcode), "<-- new char");
          suffix = 1;
        }
        console.log(suffix, "<-- Suffix");
        var res = String.fromCharCode(prefix_charcode).concat(
          suffix.toLocaleString("en-US", {
            minimumIntegerDigits: 2,
            useGrouping: false,
          })
        );
        console.log(res, "<-- result");
        worknums[i] = res;
        console.log(worknums, "<-- worknums");
      }
      return worknums;
    },

    async submit() {
      let newlist = await this.createOrder();
      //gives FSC BUTTON A SPACE
      if (this.allowSpaces == undefined) {
        this.allowSpaces = " ";
      }
      var creator = firebase.auth().currentUser.email.split("@")[0];
      // if (!this.$refs.form.validate()) this.$refs.form.reset(); //IF THERE IS A PROBLEM VALIDATING THEN RESET FORM
      //DEPENDANT ON PRODUCT SELECTED THEN CREATE THE OBJECTS
      this.loading = true;
      for (var y = 0; y < this.product.length; y++) {
        switch (this.product[y]) {
          case "Doors":
            let order = {
              createdBy: creator,
              status: "booked",
              notes: " ",
              notes2: " ",
              jobNotes: " ",
              worknum: newlist[y],
              customer: this.customer,
              contract: this.contract,
              ordernum: this.ordernum,
              product: this.product[y],
              location: this.location,
              progress: 0,
              invoiceNum: " ",
              deliveryNum: " ",
              fsc: this.allowSpaces,
              date: moment(new Date()).format("YYYY-MM-DD HH:mm"),
              qty: this.qty[y + 1],
              steps: {
                factory: false,
                saw: false,
                lip: false,
                press: false,
                cnc: false,
                bench: false,
                spray: false,
              },
              objects: {
                "A-factory": {
                  state: false,
                  user: "",
                  timestamp: "",
                },
                "B-saw": {
                  state: false,
                  user: "",
                  timestamp: "",
                },
                "C-lip": {
                  state: false,
                  user: "",
                  timestamp: "",
                },
                "F-press": {
                  state: false,
                  user: "",
                  timestamp: "",
                },
                "G-cnc": {
                  state: false,
                  user: "",
                  timestamp: "",
                },
                "H-bench": {
                  state: false,
                  user: "",
                  timestamp: "",
                },
                "I-spray": {
                  state: false,
                  user: "",
                  timestamp: "",
                },
              },
            };
            db.collection("orders")
              .add(order)
              .then(() => {
                console.log("ADDED to db");
                this.loading = false;
                this.dialog = false;
                this.$emit("orderCreated");
              });

            break;
          case "Frame":
            let frame = {
              status: "booked",
              createdBy: creator,
              notes: " ",
              notes2: " ",
              worknum: newlist[y],
              customer: this.customer,
              contract: this.contract,
              ordernum: this.ordernum,
              product: this.product[y],
              location: this.location,
              invoiceNum: " ",
              deliveryNum: " ",
              progress: 0,
              fsc: this.allowSpaces,
              date: moment(new Date()).format("YYYY-MM-DD HH:mm"),
              qty: this.qty[y + 1],
              steps: {
                factory: false,
                mach: false,
                mill: false,
                bench: false,
                spray: false,
                cnc: false,
              },
              objects: {
                "A-factory": {
                  state: false,
                  user: "",
                  timestamp: "",
                },
                "D-mach": {
                  state: false,
                  user: "",
                  timestamp: "",
                },
                "E-mill": {
                  state: false,
                  user: "",
                  timestamp: "",
                },
                "F-press": {
                  state: false,
                  user: "",
                  timestamp: "",
                },
                "G-cnc": {
                  state: false,
                  user: "",
                  timestamp: "",
                },
                "H-bench": {
                  state: false,
                  user: "",
                  timestamp: "",
                },
                "I-spray": {
                  state: false,
                  user: "",
                  timestamp: "",
                },
              },
            };
            db.collection("orders")
              .add(frame)
              .then(() => {
                console.log("ADDED to db");
                this.loading = false;
                this.dialog = false;
                this.$emit("orderCreated");
              });
            break;
          case "Timber Section":
            let timber = {
              status: "booked",
              createdBy: creator,
              notes: " ",
              notes2: " ",
              worknum: newlist[y],
              customer: this.customer,
              contract: this.contract,
              ordernum: this.ordernum,
              product: this.product[y],
              location: this.location,
              invoiceNum: " ",
              deliveryNum: " ",
              progress: 0,
              fsc: this.allowSpaces,
              date: moment(new Date()).format("YYYY-MM-DD HH:mm"),
              qty: this.qty[y + 1],
              steps: {
                factory: false,
                mach: false,
                mill: false,
                bench: false,
                spray: false,
                cnc: false,
              },
              objects: {
                "A-factory": {
                  state: false,
                  user: "",
                  timestamp: "",
                },
                "H-bench": {
                  state: false,
                  user: "",
                  timestamp: "",
                },
                "I-spray": {
                  state: false,
                  user: "",
                  timestamp: "",
                },
              },
            };
            db.collection("orders")
              .add(timber)
              .then(() => {
                console.log("ADDED to db");
                this.loading = false;
                this.dialog = false;
                this.$emit("orderCreated");
              });
            break;
          case "Screens":
            let screen = {
              status: "booked",
              createdBy: creator,
              notes: " ",
              notes2: " ",
              // worknum: this.bcode +(count++).toLocaleString('en-US', {minimumIntegerDigits: 2, useGrouping:false}),
              worknum: newlist[y],
              customer: this.customer,
              contract: this.contract,
              ordernum: this.ordernum,
              product: this.product[y],
              location: this.location,
              invoiceNum: " ",
              deliveryNum: " ",
              progress: 0,
              fsc: this.allowSpaces,
              date: moment(new Date()).format("YYYY-MM-DD HH:mm"),
              steps: {
                factory: false,
                mach: false,
                mill: false,
                bench: false,
                spray: false,
                cnc: false,
              },
              objects: {
                "A-factory": {
                  state: false,
                  user: "",
                  timestamp: "",
                },
                "H-bench": {
                  state: false,
                  user: "",
                  timestamp: "",
                },
                "I-spray": {
                  state: false,
                  user: "",
                  timestamp: "",
                },
              },
            };
            db.collection("orders")
              .add(screen)
              .then(() => {
                console.log("ADDED to db");
                this.loading = false;
                this.dialog = false;
                this.$emit("orderCreated");
              });
            break;
          case "Glass":
            let glass = {
              status: "booked",
              createdBy: creator,
              notes: " ",
              notes2: " ",
              // worknum: this.bcode +(count++).toLocaleString('en-US', {minimumIntegerDigits: 2, useGrouping:false}),
              worknum: newlist[y],
              customer: this.customer,
              contract: this.contract,
              ordernum: this.ordernum,
              location: this.location,
              invoiceNum: " ",
              deliveryNum: " ",
              progress: 0,
              product: this.product[y],
              fsc: this.allowSpaces,
              date: moment(new Date()).format("YYYY-MM-DD HH:mm"),
              qty: this.qty[y + 1],
              steps: {
                factory: false,
                bench: false,
                spray: false,
              },
              objects: {
                "A-factory": {
                  state: false,
                  user: "",
                  timestamp: "",
                },
                "H-bench": {
                  state: false,
                  user: "",
                  timestamp: "",
                },
                "I-spray": {
                  state: false,
                  user: "",
                  timestamp: "",
                },
              },
            };
            db.collection("orders")
              .add(glass)
              .then(() => {
                console.log("ADDED to db");
                this.loading = false;
                this.dialog = false;
                this.$emit("orderCreated");
              });
            break;
          case "Ironmongory":
            let iron = {
              status: "booked",
              createdBy: creator,
              notes: " ",
              notes2: " ",
              // worknum: this.bcode +(count++).toLocaleString('en-US', {minimumIntegerDigits: 2, useGrouping:false}),
              worknum: newlist[y],
              customer: this.customer,
              contract: this.contract,
              ordernum: this.ordernum,
              location: this.location,
              invoiceNum: " ",
              deliveryNum: " ",
              progress: 0,
              product: this.product[y],
              fsc: this.allowSpaces,
              date: moment(new Date()).format("YYYY-MM-DD HH:mm"),
              qty: this.qty[y + 1],
            };
            db.collection("orders")
              .add(iron)
              .then(() => {
                console.log("ADDED to db");
                this.loading = false;
                this.dialog = false;
                this.$emit("orderCreated");
              });
            break;
        }
      }
      this.$refs.form.reset();
      this.loading = false;
    },
  },
};
</script>
<style>
table.v-table tbody td:first-child,
table.v-table tbody td:not(:first-child),
table.v-table tbody th:first-child,
table.v-table tbody th:not(:first-child),
table.v-table thead td:first-child,
table.v-table thead td:not(:first-child),
table.v-table thead th:first-child,
table.v-table thead th:not(:first-child) {
  padding: 0 1px;
}
</style>
